import { DropdownFilter } from "../../../../components/Filters/DropdownFilter";
import { useSearchContext } from "../../contexts";
import { SourceGroupChooser } from "../SourceGroupChooser";
import { useTranslation } from "react-i18next";

interface SourceGroupChooserDropdownProps {
  onOpenChange?: (isOpen: boolean) => void;
}

export const SourceGroupChooserDropdown: React.FC<SourceGroupChooserDropdownProps> = ({ onOpenChange }) => {
  const { state } = useSearchContext();
  const { t } = useTranslation();
  return (
    <DropdownFilter
      title={t("Actor groups")}
      counter={state.draftFilters.sourceGroups.value.length}
      isExclude={state.draftFilters.sourceGroups.exclude}
      onOpenChange={onOpenChange}
    >
      <SourceGroupChooser />
    </DropdownFilter>
  )
};
